import { ComponentType } from 'react';
import { UserPermission } from '@synergy/models';

import { AccessControl } from './access-control';

export const AccessControlConnectPermission =
    (allowedPermissions?: UserPermission | UserPermission[], redirect = false) =>
    <P extends object>(WrappedComponent: ComponentType<P>) =>
    (props: P) =>
        (
            <AccessControl allowedPermissions={allowedPermissions} redirect={redirect}>
                <WrappedComponent {...props} />
            </AccessControl>
        );
